export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "zonesCategories.worker.8fb259e49f0ffbd669f6.worker.js");
}
